<template>
  <div class="FinishOrder">
    <top-page-title>Завършване на поръчката</top-page-title>
    <section class="section bg-grey-lightest py-12">
      <div class="container">
        <component
          :order-data="orderData"
          :is="finalizeComponent"
        />
      </div>
    </section>
  </div>
</template>

<script>
import Store from '@/store'

import { mapState } from 'vuex'
import FinalizePaymentEpay from '@/components/FinalizePaymentEpay'
import FinalizePaymentBonus from '@/components/FinalizePaymentBonus'

/**
 * @module FinishOrder
 */
export default {
  name: 'FinishOrder',
  components: {
    FinalizePaymentEpay,
    FinalizePaymentBonus
  },
  props: {
    gateway: {
      type: String,
      required: true
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!Store.getters['shop/hasOrderData']) return next({ name: 'home' })
    next()
  },
  computed: {
    ...mapState('shop', ['orderData']),
    finalizeComponent () {
      return `finalize-payment-${this.gateway}`
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
